import { createContext } from 'react';

export const IdiomaContext = createContext();